import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Components
import Navbar from './Components/Navbar.jsx';
import Footer from './Components/Footer.jsx';
import Sidebar from './Components/Sidebar.jsx';

// Core Pages
import Home from './Pages/Home.jsx';
import About from './Pages/About.jsx';
import Contact from './Pages/Contact.jsx';
import FAQ from './Pages/FAQ.jsx';
import Blogs from './Pages/Blogs.jsx';
import Login from './Pages/Login.jsx';
import Email from './Pages/Email.jsx';
import Popup from './Pages/Popup.jsx';
import LetsConnect from './Pages/Lets_connect.jsx';

// Services
import Services from './Pages/Services.jsx';
import Elevation from './Pages/Elevation.jsx';
import PlanningDrawing from './Pages/Planing_drawing.jsx';
import StructuralDrawing from './Pages/Structural_drawing.jsx';
import InteriorDesigning from './Pages/Interior_designing.jsx';
import MepDrawing from './Pages/Mep_drawing.jsx';
import ElectricalDrawing from './Pages/Electrical_drawing.jsx';

// Gallery / Media
import Gallery from './Pages/Gallery.jsx';
import BabyShoot from './Pages/BabyShoot.jsx';
import PreWedding from './Pages/PreWedding.jsx';
import FunctionHall from './Pages/FunctionHall.jsx';

// Projects
import Resorts from './Pages/Resorts.jsx';
import VenturesOverview from './Pages/VenturesOverview.jsx';
import HotelRooms from './Pages/HotelRooms.jsx';
import PoolOverviewCard from './Pages/PoolOverviewCard.jsx';
import RestaurantOverview from './Pages/RestaurantOverview.jsx';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />

        <Routes>
          {/* Redirect base path to /home */}
          <Route path="/" element={<Navigate replace to="/home" />} />

          {/* Core Pages */}
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/login" element={<Login />} />
          <Route path="/email" element={<Email />} />
          <Route path="/popup" element={<Popup />} />
          <Route path="/sidebar" element={<Sidebar />} />
          <Route path="/lets-connect" element={<LetsConnect />} />

          {/* Services */}
          <Route path="/services" element={<Services />} />
          <Route path="/elevation" element={<Elevation />} />
          <Route path="/planning-drawing" element={<PlanningDrawing />} />
          <Route path="/structural-drawing" element={<StructuralDrawing />} />
          <Route path="/interior-designing" element={<InteriorDesigning />} />
          <Route path="/mep-drawing" element={<MepDrawing />} />
          <Route path="/electrical-drawing" element={<ElectricalDrawing />} />

          {/* Gallery / Events */}
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/baby-shoot" element={<BabyShoot />} />
          <Route path="/pre-wedding" element={<PreWedding />} />
          <Route path="/function-hall" element={<FunctionHall />} />

          {/* Projects */}
          <Route path="/resorts" element={<Resorts />} />
          <Route path="/ventures" element={<VenturesOverview />} />
          <Route path="/hotel-rooms" element={<HotelRooms />} />
          <Route path="/pool-overview" element={<PoolOverviewCard />} />
          <Route path="/restaurant-overview" element={<RestaurantOverview />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
